module.exports = __webpack_public_path__ + "img/img97.f163fd21.jpg";